import {injectable, Inject} from 'inversify-props';
import HttpClient from "./http-client";

@injectable()
export class CrmLogService {

    public static readonly LOG_REACHED_SEARCH = 100;
    public static readonly LOG_SELECTED_FLIGHT = 220;
    public static readonly LOG_CLICKED_BOOK = 200;
    public static readonly LOG_FLIGHTS_EXPIRED = 210;
    public static readonly LOG_REACHED_PURCHASE = 300;

    @Inject() httpClient: HttpClient;

    constructor() {
    }

    public add(code: number, data: any = {}) {
        let payload: any = {code}
        for (let i in data) {
            payload[i] = data[i];
        }
        return this.httpClient.post('/log/add', payload)
            .then(res => {
                return res;
            });
    }

}